import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authService.getUser().pipe(
      map((user) => {
        if (user) {
          if (route.data['roles'] && route.data['roles'].includes('*') && route.data['roles'].length === 1) {
            return true;
          }

          const roles = route.data['roles'] as string[];
          if (user && roles && user.roles.some((role: string) => roles.includes(role))) {
            return true;
          }
          this.router.navigate(['/error?code=403']);
          return false;
        } else {
          this.router.navigate(['/login']);
          return false;
        }
      }),
    );
  }
}
